import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import './cam-context-switcher-organization-list';
import './cam-context-switcher-costcenter-list';
import './cam-context-switcher-workspace-list';

const tagName = 'cam-context-switcher-panel';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherPanel extends HTMLElement {

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
  }

  connectedCallback() {
    this.classList.add(tagName);
    this.innerHTML = template();
    let camContextSwitcherOrganizationList = document.querySelector('#cam-context-switcher-organization-list');
    let camContextSwitcherCostcenterList = document.querySelector('#cam-context-switcher-costcenter-list');
    let camContextSwitcherWorkspaceList = document.querySelector('#cam-context-switcher-workspace-list');
    camContextSwitcherOrganizationList.renderCamOrganizationList(this.datastore.organizations);
    camContextSwitcherCostcenterList.renderCamCostcenterList(this.datastore.costcenters);
    camContextSwitcherWorkspaceList.renderCamWorkspaceList(this.datastore.workspaces);
  }

}

customElements.define(tagName, CamContextSwitcherPanel);



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-panel.js